module.exports = __webpack_public_path__ + "static/media/icon-stats.7790da4b.svg";